<template>
  <div class="flex justify-center card">
    <Dialog v-model:visible="visible" modal :header="header" class="w-[40rem] sm:ml-64" @close="closeModal" :closeOnEscape="true" :closeOnBackdrop="true">
      <slot />
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import Dialog from 'primevue/dialog';

const visible = defineModel('visible', {
  type: Boolean,
  default: false
});

defineProps({
  header: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
}

</script>
